/**
 * @viewport both
 * Logs register CTA click from marketing email, then redirects to registration.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Container, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import api from '@/core/api/api';

export default function MarketingClickRedirect() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) {
      setError('This link is invalid.');
      return;
    }
    (async () => {
      try {
        const res = await api.get('/public/marketing/click', { params: { token } });
        const data = res.data?.data || res.data;
        const url = data?.redirect_url;
        if (!url) {
          setError('Unable to continue to registration.');
          return;
        }
        window.location.replace(url);
      } catch (e) {
        setError(e?.response?.data?.message || 'This link is invalid or has expired.');
      }
    })();
  }, [token]);

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Taking you to registration…
          </Typography>
        </Box>
      )}
    </Container>
  );
}
